import * as React from "react";
import { ToastContext } from "./context";
import { type ToasterToast } from "@/components/ui/toasts/types";

interface Props {
  children: React.ReactNode;
}

export const ToastProvider: React.FC<Props> = ({ children }) => {
  const [state, setState] = React.useState<ToasterToast[]>([]);

  return <ToastContext.Provider value={{ state, setState }}>{children}</ToastContext.Provider>;
};
